import React from 'react'
import ProductSlider from '../ProductSlider'

function RelatedProduct({relatedProducts,Heading}) {
  return (
    <div className="-mx-4 md:-mx-0 related-products-container">
          <div className="p-4 text-center heading">
            <h3 className="font-primaryFont text-2xl uppercase">
               {Heading}
            </h3>
          </div>
          <ProductSlider products={relatedProducts} howManyProductShowCss="w-1/3 md:w-1/4 lg:w-1/6" />
        </div>
  )
}

export default RelatedProduct